import { render, staticRenderFns } from "./postman.vue?vue&type=template&id=4dcf97f8&"
import script from "./postman.vue?vue&type=script&setup=true&lang=js&"
export * from "./postman.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./postman.vue?vue&type=style&index=0&id=4dcf97f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports